import React, {useEffect, useState} from "react";

import '../DashboardWidget.scss'
import './ShiftOperatorsWidget.scss'
import {Loading, ContainedList, ContainedListItem, Tag} from "@carbon/react";
import {useRecoilValue} from "recoil";
import {grpcShiftServiceSelector} from "../../../state/grpc";

const ShiftOperatorsWidget = () => {
  const shiftService = useRecoilValue(grpcShiftServiceSelector)
  const [loading, setLoading] = useState(true)
  const [shifts, setShifts] = useState([])
  const [error, setError] = useState(false)

  useEffect(() => {
    const req = new proto.api.ListShiftsRequest()
    shiftService.listShifts(req, null, (err, resp) => {
      if (err != null) {
        console.error(err)
        setError(true)
      } else {
        setShifts(resp.toObject().shiftsList.filter(shift => shift.enabled))
      }
      setLoading(false)
    })
  }, [])

  if (loading) {
    return (
      <div className="widget-position-centered-loading">
        <Loading withOverlay={false}/>
      </div>
    )
  }

  if (error) {
    return (
      <div style={{paddingLeft: "1rem"}} className="widget-position-centered-loading">
        <span>Non è stato possibile caricare gli operatori di turno</span>
      </div>
    )
  }

  if (shifts.length === 0) {
    return (
      <div style={{paddingLeft: "1rem"}} className="widget-position-centered-loading">
        <span>Non ci sono operatori in turno al momento</span>
      </div>
    )
  }

  return (
    <ContainedList
      label={
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}>
          <span>Lista operatori</span>
          <Tag size="sm">{shifts.length}</Tag>
        </div>
      }
      kind="on-page">
      {
        shifts.map(shift =>
          <ContainedListItem key={shift.id}>
            <a href={"mailto:" + shift.email}><span style={{fontWeight: "bold"}}>{shift.username}</span></a>
            <span style={{fontWeight: "300", fontSize: "12px"}}> in turno da {shift.updatedat}</span></ContainedListItem>
        )
      }
    </ContainedList>
  )
}

export default ShiftOperatorsWidget